// @ts-ignore
import Quill from '@cimpress-technology/quill/core';

export const { StyleAttributor, Scope } = Quill.import('parchment');

class ColorAttributor extends StyleAttributor {
    public converter: (value: any) => string = (value) => value;

    public add(node: HTMLElement, value: any) {
        if (!super.canAdd(node, value)) {
            return false;
        }

        // preserve source color value (ex: CDIF color format)
        // eslint-disable-next-line no-param-reassign
        node.dataset.color = JSON.stringify(value);

        // add style property color resulting from this.converter which should
        // have css accepted formats (e.g.'rgb(NUM,NUM,NUM)' or '#HHHHHH')
        const converted = this.converter(value);
        const result = super.add(node, converted);

        // sets a custom CSS property that is used to style the text decoration color
        node.style.setProperty('--ql-color-attribute', converted);

        return result;
    }

    public remove(node: HTMLElement): void {
        node.style.removeProperty('--ql-color-attribute');
        super.remove(node);
    }

    // get source color value embedded on element
    // eslint-disable-next-line class-methods-use-this
    public value(node: HTMLElement): any {
        // This statement is needed because the list marker color attributor conflicts with this attributor since they listen to the same property.
        if (!node.dataset.color) {
            return '';
        }
        return JSON.parse(node.dataset.color!);
    }
}

// @ts-ignore
export default new ColorAttributor('color', 'color', { scope: Scope.INLINE });
// @ts-ignore
export const BlockColorAttributor = new ColorAttributor('blockColor', 'color', { scope: Scope.BLOCK });
